/**
 * Login step content utilities
 * Maps step numbers to translation keys for titles and descriptions
 */
import { t } from "i18next"
import { LoginStep } from "../constants/loginSteps"

interface StepContent {
  title: string
  description: string
}

// Translation key mapping - translations are called at runtime
const STEP_CONTENT_KEYS: Partial<Record<LoginStep, { titleKey: string; descriptionKey: string }>> = {
  [LoginStep.ROLE_SELECTION]: {
    titleKey: "login.roleSelectionTitle",
    descriptionKey: "login.roleSelectionDescription",
  },
  [LoginStep.ADMIN_LOGIN]: {
    titleKey: "login.title",
    descriptionKey: "login.description",
  },
  [LoginStep.STAFF_LOGIN]: {
    titleKey: "login.title",
    descriptionKey: "login.description",
  },
  [LoginStep.OTP_VERIFICATION]: {
    titleKey: "login.otpTitle",
    descriptionKey: "login.otpDescription",
  },
  [LoginStep.FORGOT_PASSWORD]: {
    titleKey: "login.forgotPasswordTitle",
    descriptionKey: "login.forgotPasswordDescription",
  },
  [LoginStep.FORGOT_PASSWORD_OTP_1]: {
    titleKey: "login.otpTitle",
    descriptionKey: "login.otpDescription",
  },
  [LoginStep.FORGOT_PASSWORD_OTP_2]: {
    titleKey: "login.otpTitle",
    descriptionKey: "login.otpDescription",
  },
  [LoginStep.CREATE_NEW_PASSWORD]: {
    titleKey: "login.createNewPasswordTitle",
    descriptionKey: "login.createNewPasswordDescription",
  },
}

/**
 * Get title and description for a given login step
 * @param step - Current login step
 * @returns Step content with title and description
 */
export const getStepContent = (step: LoginStep): StepContent => {
  const keys = STEP_CONTENT_KEYS[step]
  if (keys) {
    return {
      title: t(keys.titleKey),
      description: t(keys.descriptionKey),
    }
  }
  
  return {
    title: t("login.title"),
    description: t("login.description"),
  }
}

